/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../onboard/activation/jp/common';
import '../common';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "JpBusiness": {
                "fields": {
                  "kanjiName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "katakanaName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "romajiName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "category": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "companyType": {
                    "type": "squareup.onboard.activation.jp.common.CompanyType",
                    "id": 6,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.onboarding.common.JpAddress",
                    "id": 7,
                    "rule": "optional"
                  },
                  "corporateNumber": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "administrativeAction": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "license": {
                    "type": "squareup.onboarding.business.License",
                    "id": 11,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": "squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 12,
                    "rule": "repeated"
                  }
                }
              },
              "License": {
                "fields": {
                  "number": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "holderName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.JpBusiness && !$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.License) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in Japan.
 *
 * SOURCE JpBusiness @ squareup/onboarding/business/jp.proto at 14:1
 */
export const JpBusiness = $root.lookupType('squareup.onboarding.business.JpBusiness');
fixType(JpBusiness);
Builder.createAndAttachToType(JpBusiness);
/**
 * Some MCCs require that the seller include license information about their business.
 * These fields are freeform and manually verified by JCB.
 *
 * SOURCE License @ squareup/onboarding/business/jp.proto at 53:1
 */
export const License = $root.lookupType('squareup.onboarding.business.License');
fixType(License);
Builder.createAndAttachToType(License);